export var Permission;
(function (Permission) {
    Permission["UxaAccess"] = "UxaAccess";
    Permission["EmerchAccess"] = "EmerchAccess";
    Permission["CsLiveAccess"] = "CsLiveAccess";
    Permission["AlertAccess"] = "AlertAccess";
    Permission["JourneyAnalysisAccess"] = "JourneyAnalysisAccess";
    Permission["PageComparatorAccess"] = "PageComparatorAccess";
    Permission["SessionReplayAccess"] = "SessionReplayAccess";
    Permission["WorkspaceAccess"] = "WorkspaceAccess";
    Permission["MappingAccess"] = "MappingAccess";
    Permission["MappingCreate"] = "MappingCreate";
    Permission["MappingEditOwn"] = "MappingEditOwn";
    Permission["MappingEditAll"] = "MappingEditAll";
    Permission["SegmentGoalAccess"] = "SegmentGoalAccess";
    Permission["SegmentGoalCreate"] = "SegmentGoalCreate";
    Permission["SegmentGoalEditOwn"] = "SegmentGoalEditOwn";
    Permission["SegmentGoalEditAll"] = "SegmentGoalEditAll";
    Permission["ZoningAccess"] = "ZoningAccess";
    Permission["ZoningCreate"] = "ZoningCreate";
    Permission["ZoningEditOwn"] = "ZoningEditOwn";
    Permission["ZoningEditAll"] = "ZoningEditAll";
    Permission["ErrorDismiss"] = "ErrorDismiss";
    Permission["ApiErrorAdditionalDetails"] = "ApiErrorAdditionalDetails";
    Permission["JiraTicketCreate"] = "JiraTicketCreate";
    Permission["ProjectCreate"] = "ProjectCreate";
    Permission["ProjectEdit"] = "ProjectEdit";
    Permission["AccountCreate"] = "AccountCreate";
    Permission["AccountEdit"] = "AccountEdit";
})(Permission || (Permission = {}));
//# sourceMappingURL=permission.js.map